import { assertNever } from "@advosys/component-react-utils";
export const getBaseUrl = () => {
    const env = getEnvironment();
    switch (env) {
        case "PROD":
            return "api.advosyscloud.com";
        case "TEST":
            return "api.advosyscloud.com";
        case "DEV":
            return "api.advosyscloud.com";
        default:
            assertNever(env);
    }
};
export const getClientId = () => {
    const env = getEnvironment();
    switch (env) {
        case "PROD":
            return "34523c7b-5a1e-42d2-a736-ba951eb66465";
        case "TEST":
            return "9cf826ff-1bd8-4f39-90c1-c47cbb61f1e6";
        case "DEV":
            return "9cf826ff-1bd8-4f39-90c1-c47cbb61f1e6";
        default:
            assertNever(env);
    }
};
const getEnvironment = () => {
    const split = window.location.host.split(".");
    if (split.length > 2) {
        const subdomain = split[0];
        switch (subdomain) {
            case "api":
            case "advowebstp":
            case "app":
            case "stage-app":
                return "PROD";
            case "apitest":
            case "advowebstt":
            case "apptest":
                return "TEST";
            default:
                return "DEV";
        }
    }
    return "DEV";
};
